"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Stack_1 = require("../Stack");
exports.CardHeader = react_1.forwardRef((props, ref) => {
    return (jsx_runtime_1.jsx(Stack_1.HStack, Object.assign({ ref: ref, px: 4, py: 3, borderBottom: "1px solid rgba(120, 120, 120, 0.1)" }, props), void 0));
});
//# sourceMappingURL=index.js.map